import { el } from 'redom';

import { stringToSVG } from 'utilities';

import './index.scss';

import codeIconString from 'assets/images/source-code-region-icon.svg?raw';
import codePreviewIconString from 'assets/images/code-preview-icon.svg?raw';

const codeIcon = stringToSVG(codeIconString);
const codePreviewIcon = stringToSVG(codePreviewIconString);

class CodePreviewToggleButton {

  constructor(configuration) {

    this.onCode = configuration.onCode;
    this.onPreview = configuration.onPreview;

    this.coding = false;

    this.codeButton = el('button', {
      onclick: this.handleCodeClick.bind(this)
    }, [
      codeIcon.cloneNode(true)
    ]);

    this.previewButton = el('button', {
      class: 'selected',
      onclick: this.handlePreviewClick.bind(this)
    }, [
      codePreviewIcon.cloneNode(true)
    ]);

    this.el = el('#code-preview-toggle-button-main', {}, [
      this.codeButton,
      this.previewButton
    ]);

  }

  handleCodeClick() {

    this.codeButton.classList.add('selected');
    this.previewButton.classList.remove('selected');

    this.onCode();

  }

  handlePreviewClick() {

    this.codeButton.classList.remove('selected');
    this.previewButton.classList.add('selected');

    this.onPreview();

  }

  update(configuration) {

    this.onCode = configuration.onCode;
    this.onPreview = configuration.onPreview;

  }

}

export default CodePreviewToggleButton;